import moment from 'moment-timezone'

const convertedTimezones = {
  'Pacific Time (US & Canada)': 'US/Pacific',
  'Mountain Time (US & Canada)': 'US/Mountain',
  'Central Time (US & Canada)': 'US/Central',
  'Eastern Time (US & Canada)': 'US/Eastern',
  'Atlantic Time (Canada)': 'Canada/Atlantic',
}

export const parseTimezone = (time, timezone) => {
  try {
    const convertedTimezone = convertedTimezones[timezone] || timezone

    return moment.tz(time, convertedTimezone).format('MMMM DD, hh:mm A')
  } catch (error) {
    console.error(error)

    return moment(time).format('MMMM DD, hh:mm A')
  }
}
